<template>
  <v-container>
    <v-card>
      <v-card-title>
        会員情報の変更
      </v-card-title>
      <v-card-subtitle>
        会員情報を設定します。
        この情報は報告書の実施者情報と連動します。
      </v-card-subtitle>
      <v-divider />
      <v-card-text>
        <v-row dense>
          <v-col cols="4">
            <h4>登録情報</h4>
          </v-col>
          <v-col cols="8">
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="form.name"
                  outlined
                  label="氏名"
                  :error-messages="validationError.name"
                  dense />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="8">
                <v-text-field
                  v-model="form.company_name"
                  outlined
                  label="所属団体"
                  :error-messages="validationError.company_name"
                  dense />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="4">
                <v-text-field
                  v-model="form.mobilephone"
                  outlined
                  label="携帯番号"
                  :error-messages="validationError.mobilephone"
                  dense />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="form.telephone"
                  outlined
                  label="TEL"
                  :error-messages="validationError.telephone"
                  dense />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="8">
                <v-text-field
                  v-model="form.email"
                  outlined
                  label="メールアドレス"
                  :error-messages="validationError.email"
                  dense />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="mt-2 mb-5" />
        <v-row dense>
          <v-col cols="4">
            <h4>(NADA登録)石綿調査診断士登録証</h4>
          </v-col>
          <v-col cols="8">
            <license-text-fields
              v-model="form.license1"
              :error="validationError.license1" />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="4">
            <h4>特定建築物石綿含有建材調査者修了証</h4>
          </v-col>
          <v-col cols="8">
            <license-text-fields
              v-model="form.license2"
              :error="validationError.license2" />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="4">
            <h4>一般建築物石綿含有建材調査者修了証</h4>
          </v-col>
          <v-col cols="8">
            <license-text-fields
              v-model="form.license3"
              :error="validationError.license3" />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="4">
            <h4>一戸建て等石綿含有建材調査者修了証</h4>
          </v-col>
          <v-col cols="8">
            <license-text-fields
              v-model="form.license4"
              :error="validationError.license4" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <global-footer>
      <template #left>
        <v-btn
          @click.prevent="onCancelClicked">
          キャンセル
        </v-btn>
      </template>
      <template #right>
        <v-btn
          color="primary"
          @click.prevent="onSaveClicked">
          保存
        </v-btn>
      </template>
    </global-footer>
  </v-container>
</template>

<script>

import LicenseTextFields from './LicenseTextFields'

export default {
  name: 'Profile',
  components: { LicenseTextFields },
  props: {
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        mobilephone: '',
        telephone: '',
        company_name: '',
        license1: {
          code: '',
          registration_date: '',
          expiration_date: '',
        },
        license2: {
          code: '',
          registration_date: '',
          expiration_date: '',
        },
        license3: {
          code: '',
          registration_date: '',
          expiration_date: '',
        },
        license4: {
          code: '',
          registration_date: '',
          expiration_date: '',
        },
      },
      validationError: {},
    }
  },
  mounted() {
    this.fetchItem()
  },
  methods: {
    async fetchItem() {
      const { data } = await window.axios.get('/api/profile')
      this.form = data
      const licenseDefault = {
        code: '',
        registration_date: '',
        expiration_date: '',
      }
      this.form.license1 = this.form.license1 ?? { ...licenseDefault }
      this.form.license2 = this.form.license2 ?? { ...licenseDefault }
      this.form.license3 = this.form.license3 ?? { ...licenseDefault }
      this.form.license4 = this.form.license4 ?? { ...licenseDefault }
    },
    onCancelClicked() {
      this.$router.push({ name: 'index' })
    },
    async onSaveClicked() {
      try {
        await window.axios.put('/api/profile', this.form)
        this.$store.commit(
          'setSystemMessage',
          { message: '会員情報を変更しました。', color: 'success' },
        )
        this.$router.push({ name: 'index' })
      } catch ({ response }) {
        if (response.status === 422) {
          this.validationError = response.data.errors
        }
      }
    },
  },
}
</script>
